export default __webpack_public_path__ + "static/139-353493580a734a90ceade23032e3d238.jpg";